import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useFlyoutMenuContext } from "@/components/General/FlyoutMenu/context/flyoutMenu.context";
import { Row } from "@/components/General/Grid/row.component";
import { Mapped } from "@/context/mapped.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Categories = ({ className, children }: Props) => {
    const { categories } = useFlyoutMenuContext();

    return (
        <Row className={cn("tw:h-full", className)}>
            <Mapped array={categories}>{children}</Mapped>
        </Row>
    );
};
